export const CatalogItemTagIcons = {
  CATALOG: 'catalog',
  PREVIOUS_ORDER: 'action-history',
  WARNING: 'warning',
  CHECKMARK: 'checkmark',
} as const

export type CatalogItemTagIcon =
  (typeof CatalogItemTagIcons)[keyof typeof CatalogItemTagIcons]
